!function (e, t) {
  "object" == typeof exports && "object" == typeof module ? module.exports = t(require("react")) : "function" == typeof define && define.amd ? define(["react"], t) : "object" == typeof exports ? exports.ReactBootstrap4Modal = t(require("react")) : e.ReactBootstrap4Modal = t(e.React);
}(window, function (e) {
  return function (e) {
    var t = {};

    function n(o) {
      if (t[o]) return t[o].exports;
      var r = t[o] = {
        i: o,
        l: !1,
        exports: {}
      };
      return e[o].call(r.exports, r, r.exports, n), r.l = !0, r.exports;
    }

    return n.m = e, n.c = t, n.d = function (e, t, o) {
      n.o(e, t) || Object.defineProperty(e, t, {
        enumerable: !0,
        get: o
      });
    }, n.r = function (e) {
      "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
        value: "Module"
      }), Object.defineProperty(e, "__esModule", {
        value: !0
      });
    }, n.t = function (e, t) {
      if (1 & t && (e = n(e)), 8 & t) return e;
      if (4 & t && "object" == typeof e && e && e.__esModule) return e;
      var o = Object.create(null);
      if (n.r(o), Object.defineProperty(o, "default", {
        enumerable: !0,
        value: e
      }), 2 & t && "string" != typeof e) for (var r in e) {
        n.d(o, r, function (t) {
          return e[t];
        }.bind(null, r));
      }
      return o;
    }, n.n = function (e) {
      var t = e && e.__esModule ? function () {
        return e.default;
      } : function () {
        return e;
      };
      return n.d(t, "a", t), t;
    }, n.o = function (e, t) {
      return Object.prototype.hasOwnProperty.call(e, t);
    }, n.p = "", n(n.s = 0);
  }([function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.ConfirmModal = void 0;
    var o = a(n(3)),
        r = a(n(6));

    function a(e) {
      return e && e.__esModule ? e : {
        default: e
      };
    }

    t.ConfirmModal = o.default, t.default = r.default;
  }, function (t, n) {
    t.exports = e;
  }, function (e, t, n) {
    e.exports = n(4)();
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var o = Object.assign || function (e) {
      for (var t = 1; t < arguments.length; t++) {
        var n = arguments[t];

        for (var o in n) {
          Object.prototype.hasOwnProperty.call(n, o) && (e[o] = n[o]);
        }
      }

      return e;
    },
        r = l(n(1)),
        a = l(n(2)),
        i = l(n(0));

    function l(e) {
      return e && e.__esModule ? e : {
        default: e
      };
    }

    var s = function s(e) {
      var t = e.visible,
          n = e.onOK,
          a = e.onCancel,
          l = e.children,
          s = e.disableButtons,
          u = void 0 !== s && s,
          c = e.okText,
          d = void 0 === c ? "OK" : c,
          f = e.cancelText,
          p = void 0 === f ? "Cancel" : f,
          b = function (e, t) {
        var n = {};

        for (var o in e) {
          t.indexOf(o) >= 0 || Object.prototype.hasOwnProperty.call(e, o) && (n[o] = e[o]);
        }

        return n;
      }(e, ["visible", "onOK", "onCancel", "children", "disableButtons", "okText", "cancelText"]);

      return r.default.createElement(i.default, o({
        visible: t
      }, b), r.default.createElement("div", {
        className: "modal-header"
      }, r.default.createElement("h5", {
        className: "modal-title"
      }, "Confirmation")), r.default.createElement("div", {
        className: "modal-body"
      }, l), r.default.createElement("div", {
        className: "modal-footer"
      }, r.default.createElement("button", {
        type: "button",
        className: "btn btn-secondary",
        onClick: a,
        disabled: u
      }, p), r.default.createElement("button", {
        type: "button",
        className: "btn btn-primary",
        onClick: n,
        disabled: u
      }, d)));
    };

    s.propTypes = {
      children: a.default.node.isRequired,
      visible: a.default.bool.isRequired,
      onOK: a.default.func.isRequired,
      onCancel: a.default.func.isRequired,
      disableButtons: a.default.bool,
      okText: a.default.string,
      cancelText: a.default.string
    }, s.defaultProps = {
      disableButtons: !1,
      okText: "OK",
      cancelText: "Cancel"
    }, t.default = s;
  }, function (e, t, n) {
    "use strict";

    var o = n(5);

    function r() {}

    function a() {}

    a.resetWarningCache = r, e.exports = function () {
      function e(e, t, n, r, a, i) {
        if (i !== o) {
          var l = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
          throw l.name = "Invariant Violation", l;
        }
      }

      function t() {
        return e;
      }

      e.isRequired = e;
      var n = {
        array: e,
        bool: e,
        func: e,
        number: e,
        object: e,
        string: e,
        symbol: e,
        any: e,
        arrayOf: t,
        element: e,
        elementType: e,
        instanceOf: t,
        node: e,
        objectOf: t,
        oneOf: t,
        oneOfType: t,
        shape: t,
        exact: t,
        checkPropTypes: a,
        resetWarningCache: r
      };
      return n.PropTypes = n, n;
    };
  }, function (e, t, n) {
    "use strict";

    e.exports = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var o = Object.assign || function (e) {
      for (var t = 1; t < arguments.length; t++) {
        var n = arguments[t];

        for (var o in n) {
          Object.prototype.hasOwnProperty.call(n, o) && (e[o] = n[o]);
        }
      }

      return e;
    },
        r = l(n(1)),
        a = l(n(2)),
        i = l(n(7));

    function l(e) {
      return e && e.__esModule ? e : {
        default: e
      };
    }

    var s = 0;

    function u() {
      0 === s && document && document.body.classList.add("modal-open"), s += 1;
    }

    function c() {
      0 === (s -= 1) && document && document.body.classList.remove("modal-open");
    }

    var d = function (e) {
      function t(e) {
        !function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t);

        var n = function (e, t) {
          if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return !t || "object" != typeof t && "function" != typeof t ? e : t;
        }(this, (t.__proto__ || Object.getPrototypeOf(t)).call(this, e));

        return n.componentDidMount = function () {
          n.props.visible && u();
        }, n.componentDidUpdate = function (e) {
          if (n.props.visible !== e.visible) {
            if (n.props.visible ? u() : c(), n.unmounting) return;
            n.props.fade ? n.setState({
              transitioning: !0,
              modalIndex: s
            }, function () {
              window.setTimeout(function () {
                n.unmounting || n.setState({
                  visible: n.props.visible
                }, function () {
                  window.setTimeout(function () {
                    n.unmounting || n.setState({
                      transitioning: !1
                    });
                  }, 150);
                });
              }, 16);
            }) : n.setState({
              visible: n.props.visible
            });
          }
        }, n.componentWillUnmount = function () {
          n.unmounting = !0, n.props.visible && c();
        }, n.stopPropagation = function (e) {
          e.stopPropagation();
        }, n.renderBackdrop = function () {
          return n.state.visible || n.state.transitioning ? r.default.createElement("div", {
            className: (0, i.default)("modal-backdrop", {
              show: n.state.visible,
              fade: n.props.fade
            }),
            onClick: n.props.onClickBackdrop,
            role: "presentation",
            style: {
              zIndex: 1040 + n.state.modalIndex
            }
          }) : null;
        }, n.render = function () {
          var e = n.props,
              t = e.wrapperProps,
              a = e.className,
              l = e.dialogClassName,
              s = (e.visible, e.onClickBackdrop),
              u = e.children,
              c = (e.fade, function (e, t) {
            var n = {};

            for (var o in e) {
              t.indexOf(o) >= 0 || Object.prototype.hasOwnProperty.call(e, o) && (n[o] = e[o]);
            }

            return n;
          }(e, ["wrapperProps", "className", "dialogClassName", "visible", "onClickBackdrop", "children", "fade"]));
          return r.default.createElement("div", t, r.default.createElement("div", o({
            className: (0, i.default)("modal", {
              show: n.state.visible,
              fade: n.props.fade
            }, a),
            style: {
              display: n.state.visible || n.state.transitioning ? "block" : "none",
              zIndex: 1040 + n.state.modalIndex + 1
            },
            role: "dialog",
            "aria-hidden": !n.state.visible,
            tabIndex: "-1",
            onClick: s
          }, c), r.default.createElement("div", {
            className: (0, i.default)("modal-dialog", l),
            role: "document",
            onClick: n.stopPropagation
          }, r.default.createElement("div", {
            className: "modal-content"
          }, u))), n.renderBackdrop());
        }, n.state = {
          visible: n.props.visible,
          modalIndex: 0
        }, n;
      }

      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            enumerable: !1,
            writable: !0,
            configurable: !0
          }
        }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
      }(t, r.default.Component), t;
    }();

    d.propTypes = {
      children: a.default.node.isRequired,
      onClickBackdrop: a.default.func,
      visible: a.default.bool.isRequired,
      wrapperProps: a.default.object,
      className: a.default.string,
      dialogClassName: a.default.string,
      fade: a.default.bool
    }, d.defaultProps = {
      onClickBackdrop: null,
      wrapperProps: null,
      className: null,
      dialogClassName: null,
      fade: !0
    }, t.default = d;
  }, function (e, t, n) {
    var o;
    /*!
      Copyright (c) 2017 Jed Watson.
      Licensed under the MIT License (MIT), see
      http://jedwatson.github.io/classnames
    */

    /*!
      Copyright (c) 2017 Jed Watson.
      Licensed under the MIT License (MIT), see
      http://jedwatson.github.io/classnames
    */

    !function () {
      "use strict";

      var n = {}.hasOwnProperty;

      function r() {
        for (var e = [], t = 0; t < arguments.length; t++) {
          var o = arguments[t];

          if (o) {
            var a = typeof o;
            if ("string" === a || "number" === a) e.push(o);else if (Array.isArray(o) && o.length) {
              var i = r.apply(null, o);
              i && e.push(i);
            } else if ("object" === a) for (var l in o) {
              n.call(o, l) && o[l] && e.push(l);
            }
          }
        }

        return e.join(" ");
      }

      e.exports ? (r.default = r, e.exports = r) : void 0 === (o = function () {
        return r;
      }.apply(t, [])) || (e.exports = o);
    }();
  }]);
});